<template>
  <div class="hs-base-component">
    <template v-if="!isMiniprogram">
      <transition :name="shouldTransition ? `vux-pop-${direction === 'forward' ? 'in' : 'out'}` : ''">
        <keep-alive v-if="$route.path !== '/login'">
          <router-view class="router-view" v-if="$route.meta.keepAlive"/>
        </keep-alive>
      </transition>
      <transition :name="shouldTransition ? `vux-pop-${direction === 'forward' ? 'in' : 'out'}` : ''">
        <router-view class="router-view" v-if="!$route.meta.keepAlive || $route.path === '/login'"/>
      </transition>
    </template>
    <template v-else>
      <keep-alive v-if="$route.path !== '/login'">
        <router-view class="router-view" v-if="$route.meta.keepAlive"/>
      </keep-alive>
      <router-view class="router-view" v-if="!$route.meta.keepAlive || $route.path === '/login'"/>
    </template>
    <!-- <div class="iphoneX"></div> -->
  </div>
</template>
<script type="text/ecmascript-6">
// 最简单的基础component, 只有一层router-view, 适用于所有页面
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
import {
  kpiUserGetUserCenterInitInfo,
  kpiWeChatOAuthWeChatJsConfigResponse,
  kpiCustomerGetSettingsAndPermission
} from 'api'
import eventBus from 'common/js/eventBus.js'
import {clearToken, getIsApp, personalRoutePush, sendMessageToApp} from '../../common/utility/utils';
import {dispatchAMapKey} from "@/store/actions";
import store from "@/store";

export default {
  created() {
    this.dispatchAMapKey()
    this._initView()
  },
  mounted() {
    if (this.$route.path !== '/login') {
      this._getInfo()
      this._getPowerAndSetting()
      this._initWechatShare()
      this.dispatchTheme()
    } else {
      this._initView()
    }

    this.version = this.VERSION
    /** 更新分享设置 */
    eventBus.$off('refreshWeChatShare');
    eventBus.$on('refreshWeChatShare', function() {
      console.log('更新微信配置')
      this._initWechatShare()
    }.bind(this))
  },
  computed: {
    ...mapState([
      'PersonalInfor',
      'PersonalPower',
      'PersonalSetting',
      'Theme',
      'AMapKey',
    ]),
    ...mapGetters([
      'direction',
      'isMiniprogram'
    ])
  },
  watch: {
    '$route'() {
      if (this.$route.path !== '/login') {
        if (this.noValue(this.PersonalInfor)) {
          this._getInfo()
        }
        if (this.noValue(this.PersonalPower) || this.noValue(this.PersonalSetting)) {
          this._getPowerAndSetting()
        }
        /** 获取主题 */
        if (this.noValue(this.Theme)) {
          this.dispatchTheme()
        }

        if (!this.AMapKey.key) {
          this.dispatchAMapKey()
        }
      }
    },
    '$route.name': {
      handler(newRouteName, oldRouteName) {
        let noTransitionRoutes = this.noTransitionRoutes
        if (noTransitionRoutes.includes(newRouteName) && noTransitionRoutes.includes(oldRouteName)) {
          this.shouldTransition = false;
        } else {
          this.shouldTransition = true;
        }
      },
      immediate: true
    },
  },
  data() {
    return {
      noTransitionRoutes: ['carOrderList', 'intlPlaneTicketInquirySheetOrderList'],
      shouldTransition: false,
      wimg: `${window.location.protocol}//${window.location.host}/logo_70.png`,
      wurl: `${window.location.protocol}//${window.location.host}/#/wechatShare`,
      wdesc: '全国服务热线: 4006-123-123',
      wtit: '恒顺商旅',
      version: this.VERSION
    }
  },
  methods: {
    ...mapActions([
      'dispatchTheme',
      'dispatchAMapKey'
    ]),
    ...mapMutations([
      'SET_IS_MINIPROGRAM',
      'SET_IS_WECHAT_BROWSER',
      'SET_IS_EMOBILE7_BROWSER',
      'UPDATE_PERSONAL_INFOR',
      'UPDATE_PERSONAL_POWER',
      'UPDATE_PERSONAL_SETTING'
    ]),
    /** 获取个人信息 */
    _getInfo () {
      kpiUserGetUserCenterInitInfo().then(res => {
        console.log('个人信息USERINFO: ', res)
        this.UPDATE_PERSONAL_INFOR(res.ResultData)
        if (res.ErrorCode === 102) {
          // 登录超时或失效清空token
          clearToken()
        }
        // 临时处理
        if (
          res.ErrorCode === 101 &&
          this.$route.path !== '/login' &&
          this.$route.path !== '/loginWayOfRecovery' &&
          this.$route.path !== '/forgetPasswordStep1' &&
          this.$route.path !== '/forgetPasswordStep2' &&
          this.$route.path !== '/forgetPasswordStep3' &&
          this.$route.path !== '/forgetPasswordEmail' &&
          this.$route.path !== '/announcement/details' &&
          this.$route.path !== '/announcement/2019'
        ) {
          let localStorage = window.localStorage
          let router = this.$router
          if (router.currentRoute.path !== '/callback') {
            localStorage.authCallbackFullPath = router.currentRoute.fullPath
            localStorage.authCallbackPath = router.currentRoute.path
          }
          let decodeRes = decodeURIComponent(res.RedirectUrl)
          // console.log('decodeRes: ', decodeRes)
          if (getIsApp()) {
            clearToken()
            sendMessageToApp()
          } else {
            // 详细备注 wap.homsom.com/README.md RemarksCode 202411290001
            let HomsomLoginType = window.localStorage.HomsomLoginType
            if (HomsomLoginType && Number(HomsomLoginType) === 2) {
              personalRoutePush({
                path: '/home',
              }, 'replace')
            } else {
              clearToken()
              window.location.href = decodeRes
            }
          }

          // this.$toast(res.ErrMsg)
          // this.$router.push('/login')
        } else if (res.ErrorCode === 101) {
          clearToken()
        }
      })
    },

    _getPowerAndSetting() {
      kpiCustomerGetSettingsAndPermission().then(res => {
        let data = res.ResultData
        // 初始化权限
        this.UPDATE_PERSONAL_POWER(data.Permission)
        // 初始化配置
        this.UPDATE_PERSONAL_SETTING(data.Settings)
      })
    },

    /** 微信相关 */
    _initView() {
      // eslint-disable-next-line
      if (!window.WeixinJSBridge || !WeixinJSBridge.invoke) {
        document.addEventListener('WeixinJSBridgeReady', this._ready(), false)
      } else {
        this._ready()
      }
    },
    _ready() {
      this.SET_IS_MINIPROGRAM(window.__wxjs_environment === 'miniprogram')
      let ua = window.navigator.userAgent.toLowerCase() // 获取判断用的对象
      this.SET_IS_WECHAT_BROWSER(/micromessenger/.test(ua))
      this.SET_IS_EMOBILE7_BROWSER(/e-mobile7/.test(ua))
    },
    _initWechatShare() {
      let params = {
        AbsoluteUri: window.location.href.split('#')[0]
      }
      kpiWeChatOAuthWeChatJsConfigResponse(params).then((res) => {
        console.log('分享： ', res)
        this._setWechatConfig(res.ResultData)
      })
    },
    _setWechatConfig(ResultData) {
      // eslint-disable-next-line
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: ResultData.AppId, // 必填，公众号的唯一标识
        timestamp: ResultData.Timestamp, // 必填，生成签名的时间戳
        nonceStr: ResultData.NonceStr, // 必填，生成签名的随机串
        signature: ResultData.Signature, // 必填，签名
        jsApiList: [
          'onMenuShareTimeline',
          'onMenuShareAppMessage'
        ]
      })
      // eslint-disable-next-line
      // wx.error(function (res) {
      //   console.log(res)
      //   alert('验证失败')
      // })
      this._shareMsg()
    },
    _shareMsg() {
      let _this = this
      // eslint-disable-next-line
      wx.ready(function () { // 需在用户可能点击分享按钮前就先调用
        _this._initView()
        // eslint-disable-next-line
        wx.onMenuShareTimeline({
          title: _this.wtit, // 分享标题
          link: _this.wurl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: _this.wimg // 分享图标
        }, function(res) {
          // 这里是回调函数
        })
        // eslint-disable-next-line
        wx.onMenuShareAppMessage({
          title: _this.wtit, // 分享标题
          desc: _this.wdesc, // 分享描述
          link: _this.wurl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: _this.wimg // 分享图标
        }, function(res) {
          // 这里是回调函数
          console.log('分享到朋友成功')
        })
      })
    }
    /***************************************************************/
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-base-component
  width 100%
  height 100%
  .router-view
    width 100%
    height 100%
    // height calc(100% - 20px)
  .iphoneX
    width 100%
    height 20px
    background-color green
</style>
